import { render, staticRenderFns } from "./SharePointFileIcon.vue?vue&type=template&id=29b0636a&"
import script from "./SharePointFileIcon.vue?vue&type=script&lang=js&"
export * from "./SharePointFileIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB03-CV-02\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29b0636a')) {
      api.createRecord('29b0636a', component.options)
    } else {
      api.reload('29b0636a', component.options)
    }
    module.hot.accept("./SharePointFileIcon.vue?vue&type=template&id=29b0636a&", function () {
      api.rerender('29b0636a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/static/Images/SharePointFileIcon.vue"
export default component.exports